import { ErrorPage404 } from "../../components/errorPageComponents/errorPage404/ErrorPage404"

export const ErrorPagePage = () => {
    return (
        <>
            <ErrorPage404 />
        </>
    )
}
